<template>
    <div>

      <ProductsListFilter />

      <BCard no-body class="mb-0">
        <!-- Filters -->
        <div class="m-2">
          <BRow>
            <!-- Per Page -->
            <BCol cols="12" md="4" lg="5" xl="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <vSelect v-model="perPage" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>{{$t('entries')}}</label>
            </BCol>

            <!-- Search -->
            <BCol cols="12" md="8" lg="7" xl="6">
              <div class="d-flex align-items-center justify-content-between">
                <!-- <BFormInput v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'"  /> -->
                <TextInputValidated :vsModel.sync="searchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
                <BDropdown
                  id="dropdown-3"
                  text="Exportar"
                  variant="success"
                  class="mr-1"
                >
                  <BDropdownItem @click="download('PDF')">PDF</BDropdownItem>
                  <BDropdownItem @click="download('CSV')">CSV</BDropdownItem>
                  <BDropdownItem @click="download('XLS')">XLS</BDropdownItem>
                </BDropdown>
                <BButton variant="primary" :to="{ name: 'products-add' }" v-if="ability.can('create', 'product')">
                  <span class="text-nowrap">{{$t('Add product')}}</span>
                </BButton>
              </div>
            </BCol>
          </BRow>
        </div>

        <!-- Table -->
        <BTable ref="refProductListTable" class="position-relative" :items="fetchProducts" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No match records found')" :sort-desc.sync="isSortDirDesc">

          <template #cell(name)="data">
            <BLink :to="{ name: 'products-view', params: { id:data.item.id } }">{{ data.item.name }}</BLink>
          </template>

          <template #cell(stock)="data">
            <BBadge pill :variant="badgeStock(data.item.stock)">{{  data.item.stock }}</BBadge>
          </template>

          <template #cell(family)="data" v-if="ability.can('read', 'product')">
            <span> {{ data.item.family.name }} </span>
          </template>

          <template #cell(family)="data" v-else>
            <span>{{ data.item.family.name }}</span>
          </template>

          <template #cell(group)="data">
            <span>{{ data.item.group ? data.item.group.name : '' }}</span>
          </template>

          <template #cell(amount)="data">
            {{new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(data.item.amount)}}
          </template>

          <template #cell(actions)="data">
            <BDropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
              </template>
              <BDropdownItem :to="{ name: 'products-view', params: { id: data.item.id } }" v-if="ability.can('read', 'product')">
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">{{$t('Details')}}</span>
              </BDropdownItem>

              <BDropdownItem :to="{ name: 'products-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'product')">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{$t('Edit')}}</span>
              </BDropdownItem>

              <BDropdownItem @click="deletePopup(data.item.id, 'products/deleteProduct')" v-if="ability.can('delete', 'product')">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{$t('Delete')}}</span>
              </BDropdownItem>
            </BDropdown>
          </template>
        </BTable>

        <!-- Paginate -->
        <div class="mx-2 mb-2">
          <BRow>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{$t('Showing')}} {{dataMeta.from}} {{$t('to')}} {{dataMeta.to}} {{$t('of')}} {{dataMeta.of}} {{$t('entries')}}</span>
            </BCol>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <BPagination v-model="currentPage" :total-rows="totalProducts" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </BPagination>
            </BCol>
          </BRow>
        </div>

      </BCard>
    </div>
  </template>

  <script>
  import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,} from 'bootstrap-vue'
  import { onUnmounted, provide, ref } from '@vue/composition-api';
  import ProductsListFilter from './ProductsListFilters.vue'
  import productsListQuery from './productsListQuery'
  import productModule from '../productModule'
  import ability from '@/libs/acl/ability'
  import popups from '@/hooks/popups'
  import vSelect  from 'vue-select'
  import store from '@/store'
  import TextInputValidated from '@/components/forms/TextInputValidated.vue'
  import exportUtils from '@/hooks/exportUtils'

  export default {
    components: { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, vSelect, ProductsListFilter, TextInputValidated },
    setup(){
      const { exportData } = exportUtils()
      const { fetchProducts, tableColumns, perPage, currentPage, totalProducts, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, refProductListTable, refetchData, familyFilter, familyOptions, taxOptions, taxFilter } = productsListQuery()
      const { deletePopup, errorToast, successToast } = popups()
      const PRODUCT_MODULE = 'products'

      provide('familyFilter', familyFilter)
      provide('families', familyOptions)
      provide('taxFilter', taxFilter)
      provide('taxes', taxOptions)

      if (!store.hasModule(PRODUCT_MODULE)) store.registerModule(PRODUCT_MODULE, productModule)

      onUnmounted(() => {
        if(store.hasModule(PRODUCT_MODULE)){
          store.unregisterModule(PRODUCT_MODULE)
        }
      })

      const download = (type) => {
        let data = {type: type, q: searchQuery.value, family: familyFilter.value, tax: taxFilter.value}
        exportData('/download-products', data, `listado_productos_${new Date(Date.now()).toLocaleDateString('es-ES')}`, type )
      }
      
      /**
       * Define el color del stock según su cantidad
       */
      const badgeStock = function(stock){
        if(stock == 0) return 'light-danger'
        if(stock > 0) return 'light-success'
      }

      return {
        fetchProducts,
        tableColumns,
        perPage,
        currentPage,
        totalProducts,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refProductListTable,
        refetchData,
        ability,
        deletePopup,
        download,
        badgeStock
      }
    }
  }
  </script>

  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
